import { render, staticRenderFns } from "./SupsisTable.vue?vue&type=template&id=1e06c7c2"
import script from "./SupsisTable.vue?vue&type=script&lang=js"
export * from "./SupsisTable.vue?vue&type=script&lang=js"
import style0 from "./SupsisTable.vue?vue&type=style&index=0&id=1e06c7c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports